import http from 'core/services/http';
import Config from 'core/config';
import { toQueryString } from 'shared/helpers';

class IrregularityService {
  static getIrregularity(irregId) {
    return http.get(`${Config.apiUrl}/irregularities/${irregId}`);
  }

  static setIrregularity(data) {
    return http.post(`${Config.apiUrl}/irregularities`, data);
  }

  static updateIrregularity(data) {
    return http.put(`${Config.apiUrl}/irregularities`, data);
  }

  static getIrregularities(personnelId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/personnel/${personnelId}/irregularities${queryString}`);
  }

  static getTcEventIrregularities(eventId) {
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/irregularities`);
  }

  static getRoomIrregularities(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/irregularities`);
  }

  static getTcEventRegs(eventId, orderParam) {
    const param = orderParam ? `?orderBy=${orderParam}`: '';
    return http.get(`${Config.apiUrl}/testcenterevent/${eventId}/regs${param}`);
  }

  static getRoomRegs(roomId, orderParam) {
    const param = orderParam ? `?orderBy=${orderParam}`: '';
    return http.get(`${Config.apiUrl}/room/${roomId}/regs${param}`);
  }
}

export default IrregularityService;
